import { render, staticRenderFns } from "./TgApp.vue?vue&type=template&id=752193b3"
import script from "./TgApp.vue?vue&type=script&lang=js"
export * from "./TgApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports